import { render } from "./ButtonInsideGradient.vue?vue&type=template&id=26141fc6&scoped=true"
import script from "./ButtonInsideGradient.vue?vue&type=script&lang=js"
export * from "./ButtonInsideGradient.vue?vue&type=script&lang=js"

import "./ButtonInsideGradient.vue?vue&type=style&index=0&id=26141fc6&scoped=true&lang=css"
import "./ButtonInsideGradient.vue?vue&type=style&index=1&id=26141fc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26141fc6"]])

export default __exports__